<div class="reorder-hint">
  <tp-icon name="icons/reorder" class="m-r-2"></tp-icon>
  {{ reorderHintText }}
</div>
